module.exports = __webpack_public_path__ + "img/c38.022f821e.png";